<template>
  <transition name="slide-in-down">
    <div class="worker-tag float" v-if="change_tags" >
      <loading-container :loading="change_tags_loader" height="99">
        <div class="worker-header">
          <div class="hitem">
            <div class="hinputs">
              <app-checkbox v-model="labels.new">Новинка</app-checkbox>
              <app-checkbox v-model="labels.action" class="ml-3">Акция</app-checkbox>
              <app-checkbox v-model="labels.preorder" class="ml-3">Предзаказной</app-checkbox>
              <app-checkbox v-model="labels.exclusive" class="ml-3">Эксклюзивный</app-checkbox>
              <app-checkbox v-model="labels.private" class="ml-3">Приватный</app-checkbox>
              <app-checkbox v-model="labels.sale" class="ml-3">Распродажа</app-checkbox>
            </div>
          </div>
        </div>
        <div class="worker-header">
          <div class="hitem">
            <div class="hinputs mr">
              <input placeholder="Назначить теги" v-model="tags">
            </div>
            <button class="worker-add" style="width: max-content; padding: 0 40px" @click="changeLabels()">Применить</button>
          </div>

        </div>
      </loading-container>
    </div>
  </transition>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import AppCheckbox from "@/components/app-checkbox";
export default {
  components: {
    AppCheckbox,
    LoadingContainer,
  },
  props: {
    change_tags: {
      type: Boolean,
      default: true
    },
    checked: {
      type: Array
    },
    default_labels: {
      type: Array
    },
    default_tags: {
      type: Array
    },
  },
  data() {
    return {
      change_tags_loader: false,
      tags: '',
      labels: {
        new: false,
        action: false,
        preorder: false,
        exclusive: false,
        private: false,
        sale: false
      }
    }
  },
  mounted() {
    if ( this.default_tags) {
      this.tags = this.default_tags.join(',');
    }
    if (this.default_labels) {
      for (let key in this.default_labels) {
        switch(this.default_labels[key]) {
          case 'Новинка':
            this.labels.new = true;
            break;
          case 'Акция':
            this.labels.action = true;
            break;
          case 'Предзаказной':
            this.labels.preorder = true;
            break;
          case 'Эксклюзивный':
            this.labels.exclusive = true;
            break;
          case 'Приватный':
            this.labels.private = true;
            break;
          case 'Распродажа':
            this.labels.sale = true;
            break;
        }
      }
    }
  },
  methods: {
    changeLabels() {
      if (this.change_tags == true) {
        this.change_tags_loader = true
        let checked = [];
        for (let key in this.checked) {
          if (this.checked[key]) {
            checked.push(key);
          }
        }
        let labels = [];

        if (this.labels.new) {
          labels.push('Новинка');
        }
        if (this.labels.action) {
          labels.push('Акция');
        }
        if (this.labels.preorder) {
          labels.push('Предзаказной');
        }
        if (this.labels.exclusive) {
          labels.push('Эксклюзивный');
        }
        if (this.labels.private) {
          labels.push('Приватный');
        }

        if (this.labels.sale) {
          labels.push('Распродажа');
        }
        this.$http.post( '/change-products-tags',{
          token: localStorage.getItem('token'),
          products: checked,
          labels: labels,
          tags: this.tags
        })
          .then(({data}) => {
            if (data.success) {
              this.$toast.success('Данные успешно отправлены!');
              this.$emit('success', {'labels': labels, 'tags': this.tags});
            }
          })
          .catch((error) => {
              console.log(error)
              this.$toast.error('Ошибка!');
          })
          .finally(() => this.change_tags_loader = false)
      }
    },
  },
}
</script>


<style scoped lang="scss">
  .worker {
    position: relative !important;

    &-container{
     width: 69%;
    }
    &-main{
      height: 500px;
      overflow-y: auto;
      border-radius: 5px;
      box-shadow: 0px 0px 3px #E5E5EA;
      outline: hidden;
      background: #fff;

      margin-right: auto;
    }
    &-table {
      border-collapse: collapse;
      width: 100%;
      background: #fff;
      border: 1px #EEF0F3 solid;
      border-radius: 5px;
      tr {
        &:nth-child(even) {
           background: #F9F9FB;
        }
      }
      th, td {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        padding: 7px 14px;
        height: 40px;
        text-align: left;
        img{
          margin-right: -11px;
          margin-left: 2px;
        }

        &:not(:last-child) {
           border-right: 1px #EEF0F3 solid;
        }
      }
      th {
        top: 0;
        margin: 0;
        background-color: white;
        z-index: 5;
        position: sticky;
        color: #2D3137;
      }
      td{
        cursor: pointer;
      }
      tr {
        color: #7A818F;
      }
    }
    &-tag{
       background: #F9F9FB;
       box-shadow: 0px 4px 30px rgba(132, 132, 132, 0.25);
       border-radius: 0px 0px 4px 4px;
       margin-top: -30px;
       padding: 20px 20px  1px 20px;
       margin-bottom: 20px;
       position: absolute;
       width: 100%;
       transition: .5s;

      &.float {
         position: absolute;
         top: 10px;
         left: 0;
         z-index: 10;
      }
    }
    &-header {
       display: flex;
       justify-content: space-between;
       align-items: center;
       margin-bottom: 16px;

      .hitem{
        width: 100%;
        display: flex;
        align-items: center;
      }

      .hinputs {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        margin: 0;

        &.no{
           max-width: 26%;
        }
        &.mr{
           margin-right: 15px;
        }
        div {
          width: 100%;
        }

        input {
          border: 1px solid #EEF0F3;
          box-sizing: border-box;
          border-radius: 4px;
          font-size: 12px;
          width: 100%;
          height: 40px;
          padding: 0 40px 0 15px;
          outline: none;
        }

        > img {
            position: absolute;
            right: 15px;
            bottom: 50%;
            transform: translateY(50%);
            width: 14px;
            height: 14px;
        }
        &-navigation{
          width: 60%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 8px 0 0;
          background-color: #FFFFFF;
          border-radius: 0px;
          button{
            height: 40px;
            border: none;
            outline: none;
            width: 100%;
            background-color: #FFFFFF;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #7A818F;
            cursor: pointer;
            padding: 0 15px;
            margin: 2px 0;
            border-radius: 0px;
          }
          hr{
            height: 20px;
            border: 1px solid #EEF0F3;
          }
        }
      }
    }
    &-add {
       padding: 0 16px;
       background: #2CB181;
       font-weight: 500;
       font-size: 14px;
       color: #FFFFFF;
       height: 40px;
       border: none;
       outline: none;
       border-radius: 4px;
       width: 25%;
       margin:0 0 0 auto ;
    }
    &-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        height: 20px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        > img {
            width: 100%;
            height: 100%;
          }
        }
    }
  }
</style>
